module.exports = __webpack_public_path__ + "static/media/MFA-Background-004.f0032c7a.png";